import React, { useState, useRef, useEffect, } from 'react';
import { ReactTabulator } from 'react-tabulator';
import { useTranslation } from 'react-i18next';
import { Modal, Row, Col, Card } from 'react-bootstrap';
import API from '../../api/api.jsx';
import CustomToast from '../../components/toast/toast.jsx';
import loader from '../../assets/img/loading.gif'

// 베트남 동 통화로 변환하는 함수
function formatMoney(amount) {
	return new Intl.NumberFormat('vi-VN', {
	  style: 'currency',
	  currency: 'VND', // 베트남 동
	}).format(amount).replace(/[₫]/g, ''); // 통화 기호만 제거
}

// 결재대기 화면에서 결재상태 클릭 시 등장하는 모달
const Loan_003_01 = ({ showModal, setShowModal, data, handleQuery}) => {
    const { t }                                                      = useTranslation();
    const [responseData, setResponseData]                            = useState([]);   // 결재선
    const [responseBankData , setResponseBankData]                   = useState([]);   // 입금은행List
    const [responseMotherBankData , setResponseMotherBankData]       = useState([]);   // 출금은행List
    const [responseMotherBanknoData , setResponseMotherBanknoData]   = useState([]);   // 출금계좌List
    
    const [responseBankValue , setResponseBankValue]                 = useState([]);   //입금계좌 은행값
    const [responseMotherBankValue , setResponseMotherBankValue]     = useState('');   //출금계좌 은행값
    const [inBankNoValue , setInBankNoValue]                         = useState('');   //입금계좌 번호값
    const [responseMotherBanknoValue , setResponseMotherBanknoValue] = useState('');   //출금계좌 번호값
    const [responseMotherRemark , setResponseMotherRemark]           = useState('');   //출금내용
    const [loanAmountValue , setLoanAmountValue]                     = useState('');   //대출금액
    const [shouldApplyRedBorder , setShouldApplyRedBorder]           = useState('');   //대출금액
    const [cardAccGb            , setcardAccGb]                      = useState('ACC');   //카드계좌구분

    const [inquiryName , setInquiryName]                             = useState('');   //예금주명값
    const [vaAcctValue , setVaAcctValue]                             = useState('');   //가상계좌 번호값
    const tableRef                                                   = useRef(null);
    const [loading, setLoading]                                      = useState(false);
    //토스트 설정
    const [toast, setToast]                                          = useState(false);
    const [text , setText]        		                             = useState('예금주조회가 완료됐습니다.');
    // Tabulator columns 목록
	const columns = [
		{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
			cell.getRow().toggleSelect();
		}},
		{ title: t('APPROVAL.결재선명', { defaultValue: '결재선명' }), field: 'line_name', headerHozAlign: 'center', hozAlign: 'center', width: 200 , visible: true},		
		{ title: t('LOAN_APPLICATION.이름', { defaultValue: '이름' }), field: 'names', headerHozAlign: 'center', hozAlign: 'center', },		
		{ title: 'ID', field: 'approval_line_id',visible:false},		

	];

    //입금은행 변경
    const handleBankChange = (e) => {
        const selectedBankId = e.target.value;
        const selectedBank = responseBankData.find(option => option.bank_id === selectedBankId);
        // console.log(selectedBankId)
        // console.log(selectedBank['bank_id'])
        // 선택된 은행의 bank_id만 저장
        // console.log()
        setResponseBankValue(selectedBank['bank_id']);
        // setResponseBankValue(selectedBank ? selectedBank.bank_id : '');
        
    };
    //카드계좌구분 변경
    const handleCardBankChange = (e) => {
        const selectedValue = e.target.value;
		setcardAccGb(selectedValue);
    };
    

	// 숫자만 입력되도록 처리하는 함수
	const handleInputChange = (e, setInputValue) => {
		setInputValue('');
		const inputValue = e.target.value;
		// const filteredValue = allowOnlyNumbers(inputValue);				
		// 숫자가 아닌 경우 이전 값 유지
		setInputValue(inputValue)
	};

    useEffect(() => {        
        //결재선data를 가져옴
        const fetchLoan00301Data = async () => {
            try {
                const data = await API.fetchLoan00301Data();                
                setResponseData(data);
            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };

        //입금은행
        const fetchLoan00301DataBank = async () => {
            try {
                const data = await API.fetchLoan00301DataBank();                         
                
                setResponseBankData(data)
                setResponseBankValue(data[0].bank_id)

            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };
        //카드계좌구분
        const fetchLoan00302DataBank = async () => {
            try {
                const data = await API.fetchLoan00301DataBank();                         
                
                setResponseBankData(data)
                setResponseBankValue(data[0].bank_id)

            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };
        //모계좌은행(촐금은행)
        const fetchLoan00301DataMotherBank = async () => {
            try {
                const data = await API.fetchLoan00301DataMotherBank();   
                setResponseMotherBankValue(data[0].bank_id)
                setResponseMotherBankData(data)

            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };
        //
        const fetchLoan00301DataMotherBankno = async () => {
            try {
                const data = await API.fetchLoan00301DataMotherBankno();                                
                setResponseMotherBanknoValue(data[0])        
                setResponseMotherBanknoData(data)

            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };

        if (showModal) {
            console.log()
            fetchLoan00301DataMotherBankno();
            fetchLoan00301DataMotherBank();
            fetchLoan00301DataBank();
            fetchLoan00301Data();            
            setLoanAmountValue(formatMoney(data[0]['loan_amount']))
        }
        
    }, [showModal]);

    let isHandlingClick = false; // 클릭 처리 여부를 나타내는 변수

    // 실행요청 버튼 클릭 시 호출되는 함수
    const handleCheck = async () => {

        if (tableRef.current) {          
            const selectedData        = tableRef.current.getSelectedData();                
            const loan_application_id = data[0].loan_application_id

            // if (vaAcctValue && inBankNoValue && selectedData.length !== 0 && inquiryName) {
            if ( inBankNoValue && selectedData.length !== 0 && inquiryName) {
                    //값들을 json으로 만들어서 던진다
                const data = {
                    loan_application_id : loan_application_id,
                    bank_id             : responseBankValue,
                    account_no          : inBankNoValue,
                    // virtual_account     : vaAcctValue,
                    account_holder      : inquiryName,
                    withdrawal_content  : responseMotherRemark,
                    loan_amount         : loanAmountValue,
                    approval_line       : selectedData[0],
                    cardAccGb           : cardAccGb
                };

                const confirmed = window.confirm(t(`COMMON.대출실행요청 되었습니다.`, { defaultValue: '대출실행요청 되었습니다.' }));

                if (confirmed) {
                    if (isHandlingClick) return; // 클릭 처리 중이면 중복 클릭 방지
        
		            isHandlingClick = true; // 클릭 처리 시작

                    setShowModal(false);

                    try {								            
                        await API.fetchLoan00301DataPOST({
                            data : data
                        });

                        setLoading(false);

                        handleQuery();
                    }catch (error) {
                        setLoading(false);
                        console.error('대출실행 에러:', error);
                    } finally {
                        isHandlingClick = false;
                    }
                } else {
                    setLoading(false);
                }                
            }else{
                alert('필수값을 입력하지 않았습니다.')
                setLoading(false);
            }            
        }
    };

     // 가상계좌 확인버튼
    // const getVaAcct = async () => {
    //     if(!vaAcctValue){
    //         setLoading(true);  
    //         try {								            
    //             const account_number = ''                

    //             const vaData = await API.fetchGetVaAcct({
    //                 account_number : account_number
    //             });                                
            
    //             setVaAcctValue(vaData.account_number)
    //             setLoading(false);
            
    //         }catch (error) {
    //             console.error('가상계좌 에러:', error);
    //             setLoading(false);
    //         }   
    //     }else{
    //         alert('가상계좌가 이미 존재합니다.')
    //     }
    // };

    // 입금계좌 확인버튼
    const inquiryBtn =async() => {

        
        if(!responseBankValue || !inBankNoValue){
            alert('Invalid account information')
            return
        }        

        try {								            
            setLoading(true);        
            const inQuiryData = await API.fetchInquiry({
                inBank      : responseBankValue,
                inBankNo    : inBankNoValue,
                amount      : loanAmountValue,
                cardAccGb   : cardAccGb
            });

            // 예금주명값 설정
            if(inQuiryData.SourceName){
                
                setInquiryName(inQuiryData.SourceName)
                setShouldApplyRedBorder(false)
                setText('예금주조회가 성공했습니다.')
                setToast(true)
                setLoading(false);

            }else{
                alert(`${inQuiryData.code} : ${inQuiryData.message}`)                
                setInquiryName('') 
                // 예금주명이 '' 값일 경우 테두리 red로 변경
                setShouldApplyRedBorder(true)
                setText('예금주조회가 실패했습니다.')
                setToast(true)
                setLoading(false);

            }

            // if (inQuiryData.code === 201) {
            if (inQuiryData.SourceName) {
                    console.log('예금주명조회 완료');				
            }
        }catch (error) {
                console.error('예금주조회 에러:', error);
        }   
    };

    const handleClose = async () => {
        if(vaAcctValue === ''){
            //
            setShowModal(false);        
            setShouldApplyRedBorder(false)   
            
        }else{
            const account_number = vaAcctValue
            // console.log(account_number)
            //가상계좌값을 불러올때 찍은 application_status 코드를 지워야함
            try {								            
                const vaData = await API.fetchGetVaAcct({
                    account_number : account_number
                });                
                
                // setVaAcctValue(vaData.account_number)
                
            }catch (error) {
                console.error('가상계좌 에러:', error);
            }   
            setShowModal(false);           
        } 
        setVaAcctValue('')
        setInBankNoValue('')
        setInquiryName('')
        setLoanAmountValue('')
        setResponseMotherRemark('')
	};

    return (        
        
        <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t(`APPROVAL.대출실행`, { defaultValue: '대출실행' })}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Card className='h-100 border-0'>
                        <div className='row'>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.출금은행`, { defaultValue: '출금은행' })}</div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <select className='form-select w-100' value={responseMotherBankValue} onChange={(e) => setResponseMotherBankValue(e.target.value)}>
                                    {responseMotherBankData.map((option, index) => (
                                        <option key={index} value={option.bank_id}>{option.bank_name}</option>
                                    ))}
                                </select>
                            </div>   
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.출금내용`, { defaultValue: '출금내용' })}</div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <input type='text' className='form-control w-100'  value={responseMotherRemark} onChange={(e) => handleInputChange(e, setResponseMotherRemark)}/>                                
                            </div>                         
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'></div>                                      
                            <div className='col-md-4 d-flex align-items-center pt-2 pb-2'></div>                                      
                        </div>

                        <div className='row'>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.출금계좌`, { defaultValue: '출금계좌' })}</div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <select className='form-select w-100' value={responseMotherBanknoValue} onChange={(e) => setResponseMotherBanknoValue(e.target.value)}>
                                    {responseMotherBanknoData.map((option, index) => (
                                        <option key={index} value={option.account_no}>{option.account_no}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.대출금액`, { defaultValue: '대출금액' })}</div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <input type='text' className='form-control w-100'  value={loanAmountValue} onChange={(e) => handleInputChange(e, setLoanAmountValue)} readOnly/>
                            </div>
                        </div>
                        <br/>
                        <div className='row'>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.입금은행`, { defaultValue: '입금은행' })}</div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <select className='form-select w-100' value={responseBankValue} onChange={handleBankChange}>
                                    {responseBankData.map((option, index) => (
                                        <option key={index} value={option.bank_id}>{option.bank_name}</option>
                                    ))}
                                </select>
                            </div>                            
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.카드계좌구분`, { defaultValue: '카드계좌구분' })}</div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <select className="form-select" id="card_acc_gb" value={cardAccGb} onChange={handleCardBankChange}>
                                    <option value="ACC">{t('CODE_INFORMATION.계좌', { defaultValue: '계좌' })}</option>
                                    <option value="PAN">{t('CODE_INFORMATION.카드', { defaultValue: '카드' })}</option>
                                </select>
                            </div>                              
                            
                        </div>

                        <div className='row'>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.입금계좌`, { defaultValue: '입금계좌' })}<span className="text-danger">*</span></div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <div className='row'>
                                    <div className='col-md-12'> {/* Input과 버튼을 가로로 나누는 컬럼 설정 */}
                                        <div className='input-group'> {/* Input 그룹 설정 */}
                                            <input type='text' className='form-control' value={inBankNoValue} onChange={(e) => handleInputChange(e, setInBankNoValue)} />
                                                <div className='input-group-append'>
                                                    <button className='btn btn-outline-secondary' onClick={inquiryBtn} type='button'>{t(`LOAN_DISBURSEMENT.확인`, { defaultValue: '확인' })}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.예금주명`, { defaultValue: '예금주명' })}<span className="text-danger">*</span></div>
                            <div className='col-md-4 pt-2 pb-2'>
                                <input type='text' className={`form-control w-100 ${shouldApplyRedBorder ? 'border-red' : ''}`}  value={inquiryName} onChange={(e) => handleInputChange(e, setInquiryName)}/>
                            </div>
                        </div>
                        {/* <div className='row'>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`LOAN_DISBURSEMENT.가상계좌`, { defaultValue: '가상계좌' })}<span className="text-danger">*</span></div>
                            <div className='col-md-4 pt-2 pb-2'>
                            <div className='row'>
                                <div className='col-md-12'> {/* Input과 버튼을 가로로 나누는 컬럼 설정 *
                                    <div className='input-group'> {/* Input 그룹 설정 *
                                        <input type='text' className='form-control' value={vaAcctValue} onChange={(e) => handleInputChange(e, setVaAcctValue)} readOnly />
                                            <div className='input-group-append'>
                                                <button className='btn btn-outline-secondary' onClick={getVaAcct} type='button'>{t(`LOAN_DISBURSEMENT.확인`, { defaultValue: '확인' })}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                            <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'></div>
                            <div className='col-md-4 pt-2 pb-2'></div>
                        </div> */}
                        {loading && 
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '50%',
                                    left: '55%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 9999,
                                }}
                            >
                                <img src={loader} alt="Loading..." />
                            </div>
                        }

                        
                    </Card>
                    <ReactTabulator
                        onRef={(r) => (tableRef.current = r.current)}
                        columns={columns}
                        data={responseData}
                        options={{
                            layout: "fitColumns",
                            height: "250px",                                                        
                            placeholder: "No Data Found",
                            rowFormatter: function (row) {
                                row.getElement().style.fontSize = "14px";
                            },
                            selectable: false, // 다중 선택 비활성화
                        }}
                        className="responsive-tabulator"
                    />
                </Modal.Body>
                <CustomToast show={toast} setToast={setToast} text={text} />

                <Modal.Footer className="d-flex justify-content-between">
                    <div>
                        <button className="btn btn-outline-gray me-1 mb-1 w-100px" onClick={handleClose}>
                            <i className="fa fa-backward"></i> {t('COMMON.이전', { defaultValue: '이전' })}
                        </button>
                    </div>

                    <div>
                        {/* <button className="btn btn-outline-danger me-1 mb-1 w-100px" onClick={handleReject}>
                            선택
                        </button> */}
                        <button className="btn btn-outline-success me-1 mb-1 w-100px" onClick={handleCheck}>
                            {t('APPROVAL.실행요청', { defaultValue: '실행요청' })}
                        </button>
                    </div>
                </Modal.Footer>
        </Modal>
    );
}

export default Loan_003_01;